import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { useApp } from "@/lib/i18n";

const EMPTY = { name: "", email: "", organisation: "", phone: "", team_size: "", message: "" };

export const EnterpriseDialog = () => {
  const { L } = useApp();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/enterprise-inquiry", f);
      toast.success(L("Terima kasih! Pasukan kami akan menghubungi anda dalam 1–2 hari bekerja.", "Thank you! Our team will contact you within 1–2 working days."));
      setF(EMPTY);
      setOpen(false);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  const field = (k, ms, en, props = {}) => (
    <div className="space-y-1.5"><Label htmlFor={`inq-${k}`}>{L(ms, en)}</Label><Input id={`inq-${k}`} value={f[k]} onChange={set(k)} className="h-10 rounded-xl" data-testid={`inquiry-${k}-input`} {...props} /></div>
  );
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="mt-6 w-full rounded-xl bg-white text-slate-900 hover:bg-slate-100" data-testid="enterprise-contact-btn">{L("Hubungi kami", "Contact us")}</Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg" data-testid="enterprise-dialog">
        <DialogHeader>
          <DialogTitle>{L("Pertanyaan pelan Organisasi / Kerajaan", "Organisation / Government plan inquiry")}</DialogTitle>
          <DialogDescription>{L("Ceritakan keperluan anda dan kami akan sediakan sebut harga.", "Tell us your needs and we'll prepare a quotation.")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          {field("name", "Nama", "Name", { required: true, minLength: 2 })}
          {field("email", "Emel rasmi", "Work email", { required: true, type: "email" })}
          {field("organisation", "Organisasi / Jabatan", "Organisation / Department", { required: true, minLength: 2 })}
          {field("phone", "No. telefon", "Phone")}
          <div className="sm:col-span-2">{field("team_size", "Anggaran bilangan pengguna", "Estimated number of users", { placeholder: "cth. 20" })}</div>
          <div className="space-y-1.5 sm:col-span-2">
            <Label htmlFor="inq-message">{L("Keperluan", "Requirements")}</Label>
            <Textarea id="inq-message" value={f.message} onChange={set("message")} maxLength={2000} rows={4} className="rounded-xl" data-testid="inquiry-message-input" placeholder={L("cth. format minit jabatan, bilangan mesyuarat sebulan, keperluan invois…", "e.g. department minutes format, meetings per month, invoicing needs…")} />
          </div>
          <Button type="submit" disabled={busy} className="rounded-xl bg-violet-600 hover:bg-violet-700 sm:col-span-2" data-testid="inquiry-submit-btn">{L("Hantar pertanyaan", "Send inquiry")}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
